export const AGENTCORE_NAME = "AgentCore"
